import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildProductStructuredData } from 'utils/StructuredData';
import { priceFormatter } from 'utils/Numbers';
import FontIcon from 'components/FontIcon';
import AffirmContainer from 'containers/AffirmContainer/AffirmContainer';
import classes from './CardProductAItem.module.scss';

const CardProductAItem = (props) => {
  const {
    product, productIndex, isSelected, onClick, hash, gridClass,
  } = props;
  const {
    price,
    originalPrice,
    displayName,
    isAffirmEligible,
    subtitle,
  } = product;

  return (
    <div className={classes.optContainer}>
      <input
        id={`${productIndex}-label-${hash}`}
        type='radio'
        name={`cardProductA-${hash}`}
        className={classes.optionInput}
        onClick={(e) => onClick(e, productIndex)}
        aria-label={displayName}
      />
      <label
        htmlFor={`${productIndex}-label-${hash}`}
        className={classNames(classes.optLabel, { [classes.selected]: isSelected })}
        key={productIndex}
      >
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: buildProductStructuredData(product) }}
        />
        <div className={classNames(classes.contentWrapper, { [classes[gridClass]]: gridClass || false })}>
          <div className={classes.content}>
            <div className={classes.titleAndInfoWrapper}>
              {displayName &&
                <div
                  className={classes.optTitle}
                  dangerouslySetInnerHTML={{ __html: displayName }}
                />}
              {subtitle &&
                <div
                  className={classes.optSubTitle}
                  dangerouslySetInnerHTML={{ __html: subtitle }}
                />}
            </div>
            {price >= 0 &&
              <div className={classes.affirmMessage}>
                <AffirmContainer price={price} isAffirmEligible={isAffirmEligible} className={classes.affirmMessage} />
              </div>}
            {price >= 0 &&
              <div className={classes.prices}>
                <div className={classes.price}>{priceFormatter(price)}</div>
                {originalPrice > price &&
                  <div className={classes.originalPrice}>{priceFormatter(originalPrice)}</div>}
              </div>}
          </div>
          <div className={classes.indicator}>
            <span className={classes.iconsWrapper}>
              <FontIcon
                title={`Remove ${displayName}`}
                icon='far fa-circle'
                className={classes.iconIndicatorOutline}
              />
              {isSelected &&
                <FontIcon
                  title={`Select ${displayName}`}
                  icon='fa fa-circle'
                  className={classes.iconIndicatorInline}
                />}
            </span>
          </div>
        </div>
      </label>
    </div>
  );
};

const ButtonT = PropTypes.shape({
  subType: PropTypes.string.isRequired,
  title: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  onClick: PropTypes.func,
});

const ProductT = PropTypes.shape({
  imageURI: PropTypes.string,
  imageAltText: PropTypes.string,
  displayName: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  brand: PropTypes.string,
  organization: PropTypes.string,
  currency: PropTypes.string,
  price: PropTypes.number,
  originalPrice: PropTypes.number,
  button: ButtonT,
});

CardProductAItem.propTypes = {
  /**
   * Product info
  */
  product: ProductT,
  /**
   * Index of this particular product in the array of products
  */
  productIndex: PropTypes.number,
  /**
   * Boolean to mark this product as selected<br>
   * Options: true or false
  */
  isSelected: PropTypes.bool,
  /**
   * Callback when clicking the product
  */
  onClick: PropTypes.func,
  /**
   * Hash code of the array of products
  */
  hash: PropTypes.string,
  /**
   * Grid css class being used in the PackageTabB widget
   * Options: grid2Cols, grid3Cols, grid4Cols, grid5Cols, grid6Cols
  */
  gridClass: PropTypes.string,
};

export default CardProductAItem;
